import styled from "styled-components";
import BackgroundImage from "../../../../Assets/bg/homepage2.png";

import {Text1} from "../../../../Components/Common/index.js";
export const Section1MainWrapper = styled.div`
  width: 100%;
  height: 100vh;
  background: url(${BackgroundImage}) no-repeat;
  background-position: 100% 25%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Heading = styled(Text1)`
  background: linear-gradient(90deg, #06d9ca 17.68%, #19b6f0 39.18%, #6e6cff 50%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;